import { IDefineCommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import { INotificationDelegate } from '../../../../global/helpers/notification_delegate';
import { FeedbackSuggestedPlanModel } from '../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { APGenericSlot } from '../../../builders/ap_generic_slot_builder';
import { ILoadCommentCommand } from '../../course_flag_dialog/commands/load_course_flag_command';
import { APUserModeConfig } from '../../user_mode_config/config/ap_user_mode_config';
import { IAPAPMarkAsMetStatusDatasource } from '../datasources/mark_as_met_status_datasource';
import { IMarkAsMetUnmetUrl } from '../stratgies/mark_as_met_unmet_url_strategy';
import { IUpdateProgramSlotCommand } from './../../../../plan/commands/update_program_slot_command';
import { MarkAsMetSlotCommandParamStrategy } from './../stratgies/mark_as_met_slot_command_param_strategy';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'markAsMetSlotCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      markAsMetUnmetUrl: IMarkAsMetUnmetUrl,
      ngAPNotificationDelegate: INotificationDelegate,
      log: any,
      ngAPMarkAsMetStatusDatasource: IAPAPMarkAsMetStatusDatasource,
      ngMarkAsMetSlotCommandParamStrategy: MarkAsMetSlotCommandParamStrategy,
      updateProgramSlotCommand: IUpdateProgramSlotCommand,
      loadCommentCommand: ILoadCommentCommand
    ) =>
      defineCommandORM('markAsMetSlotCommand', (deferred, slot: APGenericSlot, comment?: string) => {
        const mamUrl = `${markAsMetUnmetUrl()}_programslot_status/`;

        const params = ngMarkAsMetSlotCommandParamStrategy.getParams(slot, comment);
        const commentUrl = ngMarkAsMetSlotCommandParamStrategy.getCommentUrl();

        const markAsMetName = 'planningMarkAsMet';
        ngAPNotificationDelegate.info({
          content: `<div l-kind="hort" l-align="center" l-width-fixed><hi-indicator theme="white" size='small' class="mrm"></hi-indicator>Marking as met</div>`,
          name: markAsMetName
        });
        $http
          .post(mamUrl, params)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngAPMarkAsMetStatusDatasource.put(data);
            return loadCommentCommand(commentUrl);
          })
          .then(() =>
            updateProgramSlotCommand(slot.programSlot.id, {
              status: params.status
            })
          )
          .then(() => {
            ngAPNotificationDelegate.dismissAlertByName(markAsMetName);
            deferred.resolve();
          })
          .catch((e) => {
            ngAPNotificationDelegate.dismissAlertByName(markAsMetName);
            ngAPNotificationDelegate.error(`Unable to mark as met: ${e.data.detail}`);
            log.error(e);
            deferred.reject(e);
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/commands/mark_as_met_slot_command.ts